/**
 * 车辆列表
 */
import { VEHICLEINSURANCECLUESLIST } from '../types';

export default {
    name: `${VEHICLEINSURANCECLUESLIST}`,
    path: '/vehicleInsuranceCluesList',
    component: () => import(/* webpackChunkName: 'vehicleInsuranceClueList' */ '@/views/vehicleInsuranceClue/'),
    redirect: { name: `${VEHICLEINSURANCECLUESLIST}Index` },
    meta: {
        title: '续保提醒线索',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${VEHICLEINSURANCECLUESLIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'vehicleInsuranceClueList' */ '@/views/vehicleInsuranceClue/home/Home.vue'),
        },
        // 详情
        {
            name: `${VEHICLEINSURANCECLUESLIST}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'vehicleInsuranceClueList' */ '@/views/vehicleInsuranceClue/detail/Detail.vue'),
        },
        // 车险出单
        {
            name: 'AutoInsuranceLeadsOrder',
            path: 'AutoInsuranceLeadsOrder',
            component: () => import('@/views/vehicleInsuranceClue/issue/InsuranceIssue.vue'),
        },
    ],
};
